import React from 'react';
import './QuestionFAQ.css';

const faqData = [
  {
    question: 'Comment fonctionnent les quiz ?',
    answer: 'Nos quiz interactifs vous présentent des questions à choix multiples ou à réponse libre. Vous pourrez passer en revue toutes les questions à la fin du quiz.',
  },
  {
    question: 'Comment annuler mon abonnement ?',
    answer: 'Vous pouvez annuler votre abonnement à tout moment depuis votre page de profil. Vous conserverez l’accès jusqu’à la fin de votre période de facturation.',
  },
  {
    question: 'Puis-je créer mes propres flashcards ?',
    answer: 'Pas encore, mais la fonctionnalité arrive très bientôt !',
  },
  {
    question: 'Quels types de sujets sont couverts ?',
    answer: 'Nous couvrons une variété de sujets incluant la géographie, l’histoire, les sciences, l’art, et bien plus encore. De nouveaux thèmes sont ajoutés régulièrement.',
  },
  {
    question: 'Puis-je utiliser l’application hors ligne ?',
    answer: 'Pour le moment, une connexion Internet est requise pour accéder aux quiz et flashcards. Une fonctionnalité hors ligne est en cours de développement.',
  },
];

const QuestionFAQ = ({ limit }) => {
  const displayedFAQs = limit ? faqData.slice(0, limit) : faqData;

  return (
    <div className="faq-container">
      {displayedFAQs.map((faq, index) => (
        <details key={index} className="faq-item">
          <summary>{faq.question}</summary>
          <p>{faq.answer}</p>
        </details>
      ))}
    </div>
  );
};

export default QuestionFAQ;